import { render, staticRenderFns } from "./contact_persons.vue?vue&type=template&id=57b2bb04&scoped=true&"
import script from "./contact_persons.vue?vue&type=script&lang=js&"
export * from "./contact_persons.vue?vue&type=script&lang=js&"
import style0 from "./contact_persons.vue?vue&type=style&index=0&id=57b2bb04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b2bb04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import { VueCardTitle }  from '@/components'
import { VueCarousel }  from '@/components'
import { VueDataTableNoData }  from '@/components'
import { VuePageWrapper }  from '@/components'
installComponents(component, {VAvatar,VBtn,VCard,VCardText,VCol,VDataTable,VDivider,VIcon,VImg,VList,VListItem,VListItemTitle,VMenu,VNavigationDrawer,VRow,VSlideYTransition,VTextField,VTooltip,VueCardTitle,VueCarousel,VueDataTableNoData,VuePageWrapper})


/* vuetify-loader */
import installIcons from "!../../../node_modules/vuetify-loader/lib/runtime/installIcons.js"
import { mdiContacts } from '@mdi/js';
import { mdiDotsVertical } from '@mdi/js';
import { mdiEye } from '@mdi/js';
import { mdiFileDocumentEdit } from '@mdi/js';
import { mdiFilterVariant } from '@mdi/js';
import { mdiMagnify } from '@mdi/js';
installIcons(component, {mdiContacts,mdiDotsVertical,mdiEye,mdiFileDocumentEdit,mdiFilterVariant,mdiMagnify})
